import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";

interface InputOutputSelectProps {
  label: string;
  fields: string[];
  shownFieldNames: string[];
  setShownFieldNames: (names: string[]) => void;
}

export default function InputOutputSelect({
  label,
  fields,
  shownFieldNames,
  setShownFieldNames,
}: InputOutputSelectProps) {
  const handleChange = event => {
    const {
      target: {value},
    } = event;
    setShownFieldNames(value);
  };

  return (
    <div>
      <FormControl style={{width: "10em"}}>
        <InputLabel id="input-select-label">{label}</InputLabel>
        <Select
          multiple
          labelId="input-select-label"
          id="input-select"
          value={shownFieldNames}
          onChange={handleChange}
          renderValue={(selected: string[]) =>
            selected.length > 0 ? selected.join(", ") : "-"
          }
        >
          {fields.map(name => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={shownFieldNames.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
